module.exports = __webpack_public_path__ + "static/media/island.081365ca.svg";